import { Tabs } from 'antd';
import { NotificationListCustomerTable } from 'features/notification/components/notification-list-table/customer-table';
import { NotificationTopBarCustomer } from 'features/notification/components/top-bar/notification-customer-top-bar';
import { NotificationCustomerFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetNotificationCustomerList } from 'features/notification/use-cases/get-customer-list';
import { useGetSelectedCustomerList } from 'features/notification/use-cases/get-selected-customer-list';
import { usePaginationParams } from 'hooks';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: any = {
    SportCategoryIds: undefined,
    EventIds: undefined,
    TicketCategoryIds: undefined,
    AgeGroupIds: undefined,
    GenderId: undefined,
    Natioanlity: undefined,
    CustomerName: undefined,
    customertype: undefined,
    SessionId: undefined,
    emailId: undefined,
    paymentStatus: undefined
};
export const CustomerViewList = () => {
    const sessionId = sessionStorage.getItem("sessionId");
    const { params, updateParams } =
        usePaginationParams<any>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
        });
    const [activeTab, setActiveTab] = useState("1");
    // const [setPaymentStatus]=useState('1')
    const { data, refetch, isFetching } = useGetNotificationCustomerList(
        { ...params, SessionId: sessionId, paymentStatus: params.paymentStatus ?? 1 },
        { retry: false, enabled: !!sessionId && activeTab === "1" }
    );
    const { params: selectedCustomerParam, updateParams: selectedUpdateParam } =
        usePaginationParams<NotificationCustomerFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
            SessionId: sessionId,
        } as any);
    const { data: selectedCustomerList, refetch: selectedCustomerListRefetch, isFetching: selectedCustomerListIsFetching } = useGetSelectedCustomerList(selectedCustomerParam, { retry: false, enabled: activeTab === "2" });
    const handleFiltersChange = (values: NotificationCustomerFilterFormValuesPaginated) => {
        if (activeTab == "1") {
            updateParams(values);
            refetch();
        } else {
            selectedUpdateParam(values);
            selectedCustomerListRefetch();
        }
    };
    useEffect(() => {
        if (sessionId) {
            updateParams({ SessionId: sessionId });
            refetch();
        }
    }, [sessionId]);
    
return (
        <>
            <NotificationTopBarCustomer
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            />
            <Tabs
                defaultActiveKey="1"
                onChange={(key) => {
                    setActiveTab(key);

                    if (key === "2") {
                        selectedCustomerListRefetch(); // 👈 trigger API
                    }
                }}
                items={[
                    {
                        key: "1",
                        label: "All Participant",
                        children: <NotificationListCustomerTable
                            isUsersListLoading={isFetching}
                            typeReportList={data?.items as any}
                            itemsCount={data?.total as number}
                            tableParams={params}
                            refetch={refetch}
                            updateParams={updateParams}

                            tabKey={1}
                        />,
                    },
                    {
                        key: "2",
                        label: "Selected Participant",
                        children: <NotificationListCustomerTable
                            isUsersListLoading={selectedCustomerListIsFetching}
                            typeReportList={selectedCustomerList?.items as any}
                            itemsCount={selectedCustomerList?.total as number}
                            tableParams={selectedCustomerParam}
                            refetch={selectedCustomerListRefetch}
                            updateParams={selectedUpdateParam}
                            tabKey={2}
                        />,
                    },
                ]}
            />
            <Outlet />
        </>
    );
};
